import texts from '../text';

export function getMessageText(queryLength, isSearching, numFound) {
    let message;
    if (queryLength > 2) {
        if (isSearching) {
            message = texts.searching;
        } else {
            if (!numFound) {
                message = texts.noResults;
            } else if (numFound > 20) {
                message = texts.tryAdvancedSearch;
            }
        }
    } else {
        message = texts.typeMore;
    }
    return message;
}
